export const UTMCookieSettings = {
    secure: process.env.SECURE_COOKIES === 'true',
    expires: 5 * 365,
    domain: process.env.COOKIE_DOMAIN,
};
